import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../components/content/axiosConfig';
import { queryKeys } from './queryKeys';

export function useFishTypes(params = { search: '' }, options = {}) {
  const hasPagination = params.page != null && params.page !== '';
  return useQuery({
    queryKey: queryKeys.fishTypes(params),
    queryFn: async () => {
      const response = await axiosInstance.get('/api/FishTypes/GetAllFishTypes', { params });
      return response.data;
    },
    staleTime: hasPagination ? 30_000 : 10 * 60_000,
    ...options,
  });
}

/** Normalized array from fish types API (handles paginated or legacy array response). */
export function normalizeFishTypesData(data) {
  if (Array.isArray(data)) return data;
  return data?.data ?? [];
}
